import { render, staticRenderFns } from "./DeveloperDialog.vue?vue&type=template&id=e44cbbee&scoped=true&"
import script from "./DeveloperDialog.vue?vue&type=script&lang=ts&"
export * from "./DeveloperDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperDialog.vue?vue&type=style&index=0&id=e44cbbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44cbbee",
  null
  
)

export default component.exports